module.exports = __webpack_public_path__ + "static/img/letstalk.db45b03d.jpg";